import axios from 'axios';
import { API_URL } from '../config';
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}

export const blockMonth = async (token: string, month: number, year: number,) => {
    const response = await axios.post(`${API_URL}/presenze/company/months-blocked/`,
      {
        month: month,
        year: year,
      },
      {
        headers: {
          'Authorization': `${token}`,
        }
      });
    return response.data;
}


export const getMonthBlocked = async (token: string, { startDate, endDate }: { startDate: string, endDate: string }, permission: string,) => {
  const response = await axios.get(`${API_URL}/presenze/company/months-blocked/`,
  {
    headers: {
      'Authorization': `${token}`,
    },
    params: {
      start_date: startDate,
      end_date: endDate,
    }, 
    permission,
  } as CustomAxiosRequestConfig);
  return response.data;
};
